import { clone, pipe, map, filter } from 'ramda';
import { shuffle, timeStringToSeconds, secondsToTimeString } from './helpers.js';
import { getPointsSchedule } from './points.js';
import { getRRT } from './round_robin.js';
import { getFolkRace} from './folkrace.js';
import { getPaymentStatus } from '../../../common/utils';


// TODO vaja oleks defineerida kõik competition ja tournament sisendParameetrid
// mitte võimaldada graafikuid luua kui osad parameetrid on puudu!
export const generateScheduleWithMeta = (teams, competition, tournament = {}) => {
  const t = clone(tournament) || {},
        beginTimeInSec = timeStringToSeconds(t.beginTime),
        lunchArr = [
          timeStringToSeconds(t.lunchBeginTime),
          timeStringToSeconds(t.lunchEndTime)
        ],
        lunchLengthInSec = lunchArr[1] - lunchArr[0],
        c = clone(competition);

  // TODO payment check!!!!
  const pTeams = preSchedule(teams, c.code);

  let matches = [];

  switch(c.competitionType) {
  case 'RRT_DE':
    matches = getRRT(pTeams, c, beginTimeInSec);
    break;
  case 'FOLKRACE':
    matches = getFolkRace(pTeams, c, beginTimeInSec);
    break;
  case 'EXTERNAL':
    matches = [];
    break;
  default:
    // TIME, POINTS, POINTS_SUMMED
    matches = getPointsSchedule(pTeams, c, beginTimeInSec);
    break;
  }

  // TODO matches are actually scheduleItems
  return {
    schedule: postSchedule(
      matches,
      competition.competitionId,
      competition.competitionType,
      lunchArr,
      lunchLengthInSec),
    meta: {
      competitionType: competition.competitionType,
      teamsCount: teams.length,
      teamsNotPaid: teams.length - pTeams.length,
      teamsInSchedule: pTeams.length,
      tournament: clone(tournament),
      lunchLengthInSeconds: lunchLengthInSec
    }
  };
};


const preSchedule = (teams, competitionCode) =>
      pipe(
        map(team => {
          team.robotNumber = competitionCode + '-' + team.robotNumber;
          team.paymentStatus = getPaymentStatus(team);
          delete team.payments;
          delete team.purchaseOrders;
          
          return team;
        }),
        filter(t => t.paymentStatus === 'CONFIRMED')
      )(shuffle(teams));


const postSchedule = (matches, competitionId, competitionType, lunchArr, lunchSec) => pipe(
  map(match => {
    match.competitionId = competitionId;
    match.teamId = match.team.teamId;
    match.userId = match.team.userId;
    match.resultUnit = competitionType === 'TIME' ? 'MILLISECONDS' : 'POINTS';

    let bTime = match.beginTime,
        eTime = match.endTime;

    //add lunch if needed
    if (lunchArr[0] && lunchArr[0] > 0 && eTime >= lunchArr[0]) {
      bTime += lunchSec;
      eTime += lunchSec;
    }

    match.beginTime = secondsToTimeString(bTime);
    match.endTime = secondsToTimeString(eTime);
    match.robotName = match.team.robotName;
    match.robotNumber = match.team.robotNumber;
    match.name = match.team.name;

    if (!match.matchType) {
      match.matchType = 'QUALIFICATION';
    }
    
    return match;
  })
)(matches);


// HARDCODED FOR FOLKRACE PAST 1st round
// const postSchedule = (matches, competitionId, competitionType, lunchArr, lunchSec) => pipe(
//   map(match => {
//     match.competitionId = competitionId;
//     match.teamId = 'NULL';

//     match.resultUnit = competitionType === 'TIME' ? 'MILLISECONDS' : 'POINTS';

//     let bTime = match.beginTime,
//         eTime = match.endTime;

//     // add lunch if needed
//     if (lunchArr[0] && lunchArr[0] > 0 && eTime >= lunchArr[0]) {
//       bTime += lunchSec;
//       eTime += lunchSec;
//     }

//     match.beginTime = secondsToTimeString(bTime);
//     match.endTime = secondsToTimeString(eTime);
//     match.robotNumber = 'PLAYOFF SLOT (2) - FINALS ';

//     if (!match.matchType) {
//       match.matchType = 'QUALIFICATION';
//     }
    
//     return match;
//   })
// )(matches);



// WEBPACK FOOTER //
// ./src/private/admin/utils/scheduler/index.js